export default __webpack_public_path__ + "static/media/koscher.958e3e08.svg";